import { HttpClient } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { Constants } from 'avn/services/constants';
import { Observable, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SitemapCustomService {
  constructor(
    private httpClient: HttpClient,
    private injector: Injector
  ) {
    this.errorHandler = this.injector.get(ErrorHandler);
  }
  private errorHandler: ErrorHandler;

  getCategoryServices(): Observable<any> {
    const endPoint = '/categories-service/';
    return this.httpClient.get(Constants.BASE_URL + endPoint).pipe(catchError(this.handleError.bind(this)));
  }

  private handleError(error: any): Observable<never> {
    // Call the global error handler
    this.errorHandler.handleError(error);

    // Re-throw the error so it can be caught by the component's subscribe error handler
    return throwError(() => error);
  }
}
